import api from './api';

export interface Purchase {
  id: string;
  paymentStatus: 'PENDING' | 'PROCESSING' | 'PAID' | 'FAILED' | 'REFUNDED' | 'CANCELLED';
  stripeSessionId: string | null;
  stripePaymentIntentId: string | null;
  amountPaid: string | null;
  paidAt: string | null;
  createdAt: string;
  updatedAt: string;
  buyer: {
    id: string;
    name: string;
    email: string;
  };
  product: {
    id: string;
    title: string;
    price: string;
    thumbnail?: string | null;
    thumbnailUrl?: string | null;
    media?: Array<{
      fileUrl?: string | null;
      key?: string | null;
    }>;
  };
}

export interface CheckoutSessionResponse {
  sessionId: string;
  url: string;
  purchase: Purchase;
}

export const purchaseService = {
  /**
   * Create Stripe checkout session for product purchase
   */
  async createCheckoutSession(productId: string): Promise<CheckoutSessionResponse> {
    const response = await api.post('/purchases/checkout', { productId });
    return response.data;
  },

  /**
   * Verify purchase after Stripe payment
   */
  async verifyPurchase(sessionId: string): Promise<Purchase> {
    const response = await api.get(`/purchases/verify/${sessionId}`);
    return response.data;
  },

  /**
   * Get all purchases for current user
   */
  async getMyPurchases(): Promise<Purchase[]> {
    const response = await api.get('/purchases/my-purchases');
    return response.data;
  },

  /**
   * Get purchase by ID
   */
  async getPurchaseById(purchaseId: string): Promise<Purchase> {
    const response = await api.get(`/purchases/${purchaseId}`);
    return response.data;
  },

  /**
   * Get recent purchases for current user (limit 5)
   */
  async getRecentPurchases(): Promise<Purchase[]> {
    const response = await api.get('/purchases/recent');
    return response.data;
  },

  /**
   * Get all sales for current seller (products sold by user)
   */
  async getMySales(): Promise<Purchase[]> {
    const response = await api.get('/purchases/my-sales');
    return response.data;
  },

  /**
   * Get recent sales for current seller (limit 5)
   */
  async getRecentSales(): Promise<Purchase[]> {
    const response = await api.get('/purchases/recent-sales');
    return response.data;
  },
};

